import { Component, OnInit } from '@angular/core';
import { LiveAbroadModel } from 'src/app/shared/models/live-abroad.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';

const FOREIGN_HOLDER = 'foreignHolder';
@Component({
  selector: 'app-foreign-products',
  templateUrl: './foreign-products.component.html',
  styleUrls: ['./foreign-products.component.scss'],
})
export class ForeignProductsComponent implements OnInit {
  listradioSelectedForeign: any[];
  selectedForeign = new LiveAbroadModel();

  constructor(
    private headerService: HeaderService,
    private abreCuentasService: AbreCuentasService,
    private navigationService: NavigationService,
    public copyService: CopyService,
    public bitacoraService: BitacoraService,
  ) {
    this.headerService.show(true, true, true);
  }

  /**
   * Summary Charge data and selected predefined 'No' Option for IsPep
   */
  ngOnInit() {
    this.listradioSelectedForeign = [{
      label: this.copyService.copies.foreign_products_radio_yes,
      elementId: 1,
      checked: false,
    },
    {
      label: this.copyService.copies.foreign_products_radio_no,
      elementId: 2,
      checked: true,
    }];
    this.getData();
  }

  /**
   * Summary Function to charge predefined data by attribute IsPep
   */
  getData() {
    if (this.abreCuentasService.getForeignSelected() === undefined ||
      this.abreCuentasService.getForeignSelected().elementId === undefined) {
      this.selectedForeign = {
        elementId: 2,
        value: this.copyService.copies.foreign_products_radio_no,
        checked: true,
      };
      this.abreCuentasService.setForeignSelected(this.selectedForeign);
    } else {
      this.selectedForeign = this.abreCuentasService.getForeignSelected();
      this.listradioSelectedForeign.forEach((value, index) => {
        if (value.elementId === this.selectedForeign.elementId) {
          this.listradioSelectedForeign[index].checked = this.selectedForeign.checked;
        } else {
          this.listradioSelectedForeign[index].checked = false;
        }
      });
    }
  }

  /**
   * Summary Set propertys to Live Abroad
   * @param event
   */
  selectradioSelectedForeign(selectedRadio: any) {
    this.selectedForeign = {
      elementId: selectedRadio.elementId,
      value: selectedRadio.label,
      checked: true,
    };
    this.abreCuentasService.setForeignSelected(this.selectedForeign);
  }

  /**
   * Summary Go to next Step
   */
  next() {

    this.abreCuentasService.setForeignSelected(this.selectedForeign);
    this.sendDataToBitacora();
    if (this.selectedForeign.elementId === 1) {
      this.navigationService.nextStep('200');
    } else {
      this.navigationService.nextStep('201');
    }
  }

  sendDataToBitacora() {
    const strSendToBitacora = `${FOREIGN_HOLDER} ` + (this.selectedForeign.elementId === 1) ? 'Si' : 'No';
    this.bitacoraService.saveDataInBitacora(strSendToBitacora);
  }
}
